import React  from 'react';
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function DownloadManagedAsinsServices(token,data) {
    return axios.post(`${CURRENT_API_URL}/campaign/downloadManagedAsins`,data, {
        headers: {
            'Authorization': token,
        },
    }).then(res => {
        // notify.NotifySuccess("Store products history are getting fetched.");        
        return (res.data);
    }).catch(() => {
        notify.NotifyError("There was a problem while downloading managed asin data. Please try again.");
        return false;
    });
}

export default DownloadManagedAsinsServices;